export type ApiPermissionTemplate = {
    id: number,
    entityType: EntityType,
    name: string,
    settings: ApiPermissionSchema,
    isSystem: boolean,
    isDefault: boolean,
}

export type ApiEntityPermission = {
    id: number,
    entityType: string,
    name: string,
    settings: ApiPermissionSchema,
}

export type ApiUserPermissionResult = {
    code: string,
    allow: boolean,
}

export type ApiPermissionSchema = {
    groups: ApiPermissionSchemaGroup[],
}

export type ApiPermissionSchemaGroup = {
    name: string,
    objects: string[],
    actions: ApiPermissionAction[],
}

export type ApiPermissionAction = {
    action: string,
    roles?: string[],
    auth?: boolean,
    scope?: string,
}

export enum AppType {
    Aps = 'aps',
}

export enum EntityType {
    ApsPlan = 'aps.plan',
    DocIssue = 'doc.issue',
}

export enum CrudAction {
    Create = 'create',
    Update = 'update',
    Delete = 'delete',
    View = 'view',
}

export enum ApsFeatureObject {
    Any = '*',
    Plans = 'plans',
    ServerMonitor = 'serverMonitor',
    Integrations = 'integrations',
    Forecasts = 'forecasts',
    Services = 'services',
    LossInfo = 'lossInfo',
    ProductionInventory = 'productionInventory',
}

export enum ApsFeatureAction {
    Any = '*',
    ListAll = 'listAll',
    ListPublished = 'listPublished',
    Delete = 'delete',
    WorkflowMgmt = 'workflowMgmt',
    CreatePlan = 'createPlan',
    PublishPlan = 'publishPlan',
}

export enum PlanSchemaObjects {
    Root = 'plan-mgmt',
    Orders = 'orders-mgmt',
    Input = 'input-data-mgmt',
    LeftOver = 'left-over-mgmt',
    Permission = 'permission-mgmt',
    Analytics = 'analytics',
    Export = 'export',
}

export enum PlanSchemaActions {
    Import = 'import',
    Export = 'export',
    Summary = 'summary',
    OpenExcel = 'excel',
    Validate = 'validate',
    CalculateVersion = 'calculate',
    ViewParameters = 'parameters',
    ViewErrors = 'errors',
    Sync = 'sync',
}


export enum ApsPlanReport {
    ConveyorLine = 'conveyorLine',
    GanttChart = 'ganttChart',
    LeadTime = 'leadTime',
    EmploymentJobs = 'employmentJobs',
    EquipmentLoading = 'equipmentLoading',
    LayingTime = 'layingTime',
    UncompletedDetail = 'uncompletedDetail',
    ProductRelease = 'productRelease',
    IterativeCalculation = 'iterativeCalculation',
    WhatIfAnalysis = 'whatIfAnalysis',
    GeneticAlgorithm = 'geneticAlgorithm',
    AllForecastsAlgorithm = 'allForecastsAlgorithm',
    PurchasedMaterialsConsumptionByDay = 'purchasedMaterialsConsumptionByDay',
    PurchasedMaterialsConsumptionByBatches = 'purchasedMaterialsConsumptionByBatches',
    PurchasedMaterialsNeeded = 'purchasedMaterialsNeeded',
    WorkScheduleByWorkshop = 'workScheduleByWorkshop',
    InputDataComparison = 'inputDataComparison',
    DirectivesImpact = 'directivesImpact',
    PlanCalculationResultsComparison = 'planCalculationResultsComparison',
    DeviationFromFirstPlanVersion = 'deviationFromFirstPlanVersion',
    DiagnosticReport = 'diagnosticReport',
    EquipmentWorksPage = 'equipmentWorksPage',
    BatchAndAdjustmentAnalytics = 'batchAndAdjustmentAnalytics',
    EffortCalculator = 'effortCalculator',
    StaffWorkload = 'staffWorkload',
}

export enum PlanExportAction {
    ExportData = 'exportData',
    ExportingTasks = 'exportingTasks',
    ExportingTasksJson = 'exportingTasksJson',
    ExportingShiftTasksPdf = 'exportingShiftTasksPdf',
}
